import { resources } from "@api"
import useGet from '@hooks/useGet'
import { useMemo } from "react"
import { OptionsType } from "react-select"

export default (id?: number | string | null) => {
    const { data: organizations, status } = useGet<Interfaces.Organization[], Interfaces.Organization[]>(resources.organizations, {
        initial: []
    })

    const options: OptionsType<{ label: string; value: string; }> = useMemo(() => 
        organizations.map(organization => ({ value: organization.id.toString(), label: organization.name })), [organizations])

    const organization = useMemo(() => {
        if (!id) return null
        return options.find(option => option.value === id.toString())
    }, [options, id])

    return { organizations, options, status, organization }
}